var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.localApplicant
    ? _c(
        "span",
        [
          _c("Messages", {
            attrs: {
              "job-profile-list-item": _vm.jobProfileListItem,
              applicant: _vm.localApplicant
            },
            on: { close: _vm.fireChange }
          }),
          _vm._v(" "),
          _c("Calendar", {
            attrs: {
              "job-profile-list-item": _vm.jobProfileListItem,
              applicant: _vm.localApplicant
            },
            on: { closeAppointments: _vm.fireChange }
          }),
          _vm._v(" "),
          _vm.permissions.favoriteJobProfile
            ? _c("Favorite", {
                attrs: {
                  "job-profile-id": _vm.jobProfile.id,
                  "job-id": _vm.jobId,
                  applicant: _vm.localApplicant,
                  "initial-favored": _vm.localApplicant.favored,
                  type: "customer"
                },
                on: { change: _vm.fireChange }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.permissions.notice
            ? _c("Notice", {
                attrs: {
                  "job-profile-id": _vm.jobProfile.id,
                  applicant: _vm.localApplicant,
                  notice: _vm.localApplicant.notice,
                  type: "customer",
                  "sub-title": _vm.applicantName
                },
                on: { change: _vm.fireChange }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.permissions.excludeJobProfile ||
          _vm.permissions.excludeComprehensive
            ? _c("Exclusion", {
                attrs: {
                  "job-profile-id": _vm.jobProfile.id,
                  "job-id": _vm.jobId,
                  applicant: _vm.localApplicant,
                  "permission-job-profile": _vm.permissions.excludeJobProfile,
                  "permission-comprehensive":
                    _vm.permissions.excludeComprehensive,
                  "initial-exclusion-type": _vm.initialExclusionType
                },
                on: { exclude: _vm.fireChange, remove: _vm.fireChange }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }